<template>
    <div id="showcomps">
        <Reminder :remdata="remdata" :remshow="remshow" />
        <loading :active.sync="fullPageWait" :can-cancel="false" :is-full-page="true" />
        <b-modal v-model="icoShow" title="Component" class="modal-alerts" :ok-only="true" ok-title="Close">
            Component: {{ icoCodice }} rev. {{ icoRev }}<br />
            <img width="100%" height="100%" :src="`${SERVER}/icon?code=${cleanCode(icoCodice)}&rev=${icoRev}`" />
        </b-modal>
        <b-modal v-model="confirmOrder" size="lg" title="Confirm your request" class="modal-alerts" :ok-only="false" ok-title="Send" @ok="sendOrder">
            <div>This is a request for a quotation, not an order. Please check below the selected item and once
                you will be fine send it to our Service Dept. They'll be back to you soon<br><br>
                Machine: {{ m.codice }}
            </div>
            <table>
                <tr>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Qty</th>
                </tr>
                <tr v-for="o of orderItems" :key="o.codice">
                    <td>{{ o.codice }}</td>
                    <td>{{ o.descrizione }}</td>
                    <td>{{ o.reorder }}</td>
                </tr>
            </table>
        </b-modal>
        <template v-if="!code3d">
            <h1>Bill of Materials 3D</h1>
            <b-button class="sendrfq" :variant="orderVariant" :disabled="orderDisabled" @click="rfq()"><v-icon name="envelope" /> SEND RFQ
            </b-button>
            <div class="billspieghe">
                Click on a unit on the layout to access the 3D drawing.<br>You will ne able to navigate into the 3D, find the parts, select<br>them and add them to the cart.<br>
                Number that appears in the brackets on the right of the code indicates how many times the code is present in the full Bill Of Material.<br>
                <b>R.</b>: The code is <b>RECOMMENDED</b>.<br>
                <b>S.R.</b>: The code is <b>STRONGLY RECOMMENDED</b><br>
                <b>A.O.</b>: The code has been <b>ALREADY ORDERED</b> in the past (even if not necessarily for the current machine).<br>
            </div>
            <div style="transform: translate(0px, 100px) scale(1);">
                <div id=mappa v-html="hmap" @click="mapclick"></div>
            </div>
        </template>
        <div v-if="!!code3d" class="fullscreenable">
            <iframe ref="frame3d" id="3d" :src="'/m3d/editor/#glb=' + code3d + '.glb'" width="100%" frameborder="0"></iframe>
        </div>
        <b-alert v-model="mailSent" variant="info" dismissible>
            Your RFQ has been sent. You'll receive a copy for your reference
        </b-alert>
    </div>
</template>
<script>
import { API } from "@/api.js";
import Reminder from "@/components/Reminder.vue";
import Loading from 'vue-loading-overlay';

const development = process.env.NODE_ENV === "development";
const SERVER = development
    ? "http://localhost:81"
    : location.protocol +
    "//" +
    location.hostname +
    (location.port ? ":" + location.port : "");

const statuses = [
    "Not Started",
    "Need Assistance",
    "In Progress",
    "Deferred",
    "Completed",
];

/* eslint no-unused-vars: "off", no-undef: "off" */
!function(t,i,o,s){function e(i,o){var e=this;this.element=i,this.options=o,this.isPopOverEnabled=0!=this.options.popOver,this.isCustomPopOver=0!=this.options.popOver.customPopOver&&this.options.popOver.customPopOver!=s,this._initImageMap(),this._initPopOver(),this._bindEvents(),this._remapZones(),t(this.element).bind("load.mapify",function(){e._remapZones()})}var r={hoverClass:!1,popOver:!1},a={hoverClass:!1,popOver:{content:function(t,i){return""},customPopOver:{selector:!1,contentSelector:".mapify-popOver-content",visibleClass:"mapify-visible",alwaysVisible:!1},delay:.8,margin:"10px",width:!1,height:!1},onAreaHighlight:!1,onMapClear:!1,instantClickOnMobile:!1},n=/(iPad|iPhone|iPod)/g.test(navigator.userAgent);e.prototype._initPopOver=function(){var i=t(this.element);this.options.popOver.margin=parseInt(this.options.popOver.margin),this._timer=null,this._popOverTransition="",this._popOverArrowTransition="",this._popOverTimeout=null,isNaN(this.options.popOver.delay)||(this._popOverTransition="all "+this.options.popOver.delay+"s",this._popOverArrowTransition="margin "+this.options.popOver.delay+"s"),this.popOver=!1,this.popOverArrow=!1,this.isPopOverEnabled&&(this.isCustomPopOver?("string"==typeof this.options.popOver.customPopOver&&(this.options.popOver.customPopOver.selector=this.options.popOver.customPopOver),this.options.popOver.customPopOver=t.extend(!0,{},a.popOver.customPopOver,this.options.popOver.customPopOver),this.popOver=t(this.options.popOver.customPopOver.selector),this.popOver.css({transition:this._popOverTransition})):(i.after('<div class="mapify-popOver" style="transition:'+this._popOverTransition+'; "><div class="mapify-popOver-content"></div><div class="mapify-popOver-arrow" style="transition:'+this._popOverArrowTransition+'; "></div></div>'),this.popOver=i.next(".mapify-popOver"),this.popOverArrow=this.popOver.find(".mapify-popOver-arrow"),this.popOver.css({width:this.options.popOver.width,height:this.options.popOver.height})))},e.prototype._initImageMap=function(){var o=this,s=t(this.element);if(this.map=s.attr("usemap"),this.zones=t(this.map).find("area"),!s.hasClass("mapify")){if(s.addClass("mapify"),this._mapWidth=parseInt(s.attr("width")),this._mapHeight=parseInt(s.attr("height")),!this._mapWidth||!this._mapHeight)return i.alert("ERROR: The width and height attributes must be specified on your image."),!1;s.wrap(function(){return'<div class="mapify-holder"></div>'}),this._mapHolder=s.parent(),t(this.map).appendTo(this._mapHolder),s.before('<img class="mapify-img" src="'+s.attr("src")+'" />'),s.before('<svg class="mapify-svg" width="'+this._mapWidth+'" height="'+this._mapHeight+'"></svg>'),this.svgMap=s.prev(".mapify-svg"),this.zones.each(function(){o._initSingleZone(this)}),s.wrap(function(){return'<div class="mapify-imgHolder"></div>'}).css("opacity",0)}},e.prototype._initSingleZone=function(i){switch(t(i).attr("shape")){case"rect":var s=t(i).attr("coords").split(","),e=[];t.each([0,1,0,3,2,3,2,1],function(t,i){e.push(s[i])}),t(i).attr("coords",e.join(",")),t(i).attr("shape","poly");break;case"poly":break;default:return console.log('ERROR: Area shape type "'+t(i).attr("shape")+'" is not supported.'),!1}t(i).attr("data-coords-default",t(i).attr("coords")),this.isPopOverEnabled&&t(i).removeAttr("alt").attr("data-title",t(i).attr("title")).removeAttr("title");var r=t(i).attr("coords").split(",");for(var a in r)r[a]=a%2==0?100*r[a]/this._mapWidth:100*r[a]/this._mapHeight;t(i).attr("data-coords",r.toString());var n=o.createElementNS("http://www.w3.org/2000/svg","polygon");n.setAttribute("class","mapify-polygon"),n.setAttribute("fill","none"),this.svgMap.append(n)},e.prototype._bindEvents=function(){var i=this,s=t(this.element);this._hasScrolled=!1,t(o).bind("touchend.mapify",function(){i._hasScrolled||i._clearMap(),i._hasScrolled=!1}).bind("touchmove.mapify",function(){i._hasScrolled=!0}),s.bind("touchmove.mapify",function(t){}),this._bindZoneEvents(),this._bindWindowEvents(),this._bindScrollParentEvents()},e.prototype._bindZoneEvents=function(){var i=this;this.zones.css({outline:"none"}),this.zones.bind("touchend.mapify",function(o){t(this).hasClass("mapify-clickable")&&(t(this).trigger("click"),i.zones.removeClass("mapify-clickable")),i.hasScrolled=!1,o.stopPropagation()}).bind("click.mapify",function(t){if(t.originalEvent!==s&&n)return!1}).bind("touchstart.mapify",function(){i.zones.removeClass("mapify-clickable"),i.svgMap.find("polygon:eq("+t(this).index()+")")[0].classList.contains("mapify-hover")?t(this).addClass("mapify-clickable"):n&&i.options.instantClickOnMobile?(console.log("Triggering instantClickOnMobile after touchstart"),t(this).addClass("mapify-clickable")):t(this).addClass("mapify-hilightable")}).bind("touchmove.mapify",function(){i.zones.removeClass("mapify-clickable mapify-hilightable")}).bind("mouseenter.mapify focus.mapify touchend.mapify",function(o){var s=this;if(!t(this).hasClass("mapify-hilightable")&&n)return!1;i._clearMap(),i.isPopOverEnabled&&i._renderPopOver(s),i._drawHighlight(s),o.preventDefault()}).bind("mouseout.mapify",function(){i._clearMap()}),n||this.zones.bind("blur.mapify",function(){i._clearMap()})},e.prototype._bindWindowEvents=function(){var o=this;t(i).bind("resize.mapify",function(){o._timer&&clearTimeout(o._timer),o._timer=setTimeout(function(){o.isPopOverEnabled&&(o.popOver.hasClass("mapify-visible")||o.isCustomPopOver||o.popOver.css({left:0,top:0})),o.svgMap.find("polygon").attr("points",""),o._remapZones();var t=o.zones[o.svgMap.find("polygon.mapify-hover").index()];t&&(o.isPopOverEnabled&&o._renderPopOver(t),o._drawHighlight(t))},100)})},e.prototype._bindScrollParentEvents=function(){var s=this;this.scrollParent=t(this.element).mapify_scrollParent(),this.scrollParent.is(o)&&(this.scrollParent=t(i)),this.scrollParent.addClass("mapify-GPU").bind("scroll.mapify",function(){n&&s.zones.removeClass("mapify-clickable mapify-hilightable"),s.isPopOverEnabled&&(!s.isCustomPopOver&&n&&(s.popOver.css({top:s.popOver.css("top"),left:s.popOver.css("left"),transition:"none"}),s.popOverArrow.css({marginLeft:s.popOverArrow.css("margin-left"),transition:"none"})),clearTimeout(t.data(this,"scrollTimer")),t.data(this,"scrollTimer",setTimeout(function(){var t=s.zones[s.svgMap.find("polygon.mapify-hover").index()];if(t){s._renderPopOver(t);var i=s._computePopOverCompensation(t),o=i[1],e=i[2];!s.isCustomPopOver&&n&&(s.popOver.css({top:e[1],left:e[0],transition:s._popOverTransition}),s.popOverArrow.css({marginLeft:o,transition:s._popOverArrowTransition}))}},100)))})},e.prototype._drawHighlight=function(i){var o=this,s=t(i).attr("data-group-id"),e=t(i).attr("data-hover-class");e=e?this.options.hoverClass+" "+e:this.options.hoverClass,s?t(i).siblings("area[data-group-id="+s+"]").addBack().each(function(){o._highlightSingleArea(this,e)}):this._highlightSingleArea(i,e),this.options.onAreaHighlight&&this.options.onAreaHighlight(this,i)},e.prototype._highlightSingleArea=function(i,o){var s=t(i).attr("data-coords").split(","),e="";for(var r in s)e+=r%2==0?t(this.element).width()*(s[r]/100):","+t(this.element).height()*(s[r]/100)+" ";var a=this.svgMap.find("polygon:eq("+t(i).index()+")")[0];t(a).attr("points",e).attr("class",function(i,s){var e=s;return t(a).hasClass("mapify-hover")||(e+=" mapify-hover",o&&(e+=" "+o)),e})},e.prototype._remapZones=function(){var i=this;this.zones.each(function(){var o=t(this).attr("data-coords").split(",");for(var s in o)o[s]=s%2==0?t(i.element).width()*(o[s]/100):t(i.element).height()*(o[s]/100);t(this).attr("coords",o.toString())})},e.prototype._renderPopOver=function(t){this.isCustomPopOver?this._renderCustomPopOver(t):this._renderDefaultPopOver(t)},e.prototype._renderCustomPopOver=function(i){var o=this,s=this.options.popOver.customPopOver,e=this.popOver;clearTimeout(this._popOverTimeout),this._popOverTimeout=setTimeout(function(){var r=o.options.popOver.content(t(i),o.element);e.find(s.contentSelector).html(r),setTimeout(function(){e.css({transition:o._popOverTransition}).addClass(s.visibleClass)},10)},100)},e.prototype._renderDefaultPopOver=function(i){var o=this,s=this.popOver.outerWidth(),e=this.options.popOver.margin,r=this.popOver,a=this.popOverArrow,n=r.attr("data-popOver-class");""!=n&&(r.removeClass(n),r.attr("data-popOver-class","")),this.scrollParent.width()-2*e<=s?(s=this.scrollParent.width()-2*e,r.css({maxWidth:s})):this._mapHolder.width()-2*e<=s?(s=this._mapHolder.width()-2*e,r.css({maxWidth:s})):r.css({maxWidth:""}),r.css({marginLeft:-s/2});var p=this._computePopOverCompensation(i),h=p[0],l=p[1],v=p[2];r.hasClass("mapify-visible")||(r.css({top:v[1],left:v[0],transition:"none"}),a.css({marginLeft:l,transition:"none"})),clearTimeout(this._popOverTimeout),this._popOverTimeout=setTimeout(function(){var s=o.options.popOver.content(t(i),o.element),e=t(i).attr("data-pop-over-class");""!=e&&(r.addClass(e),r.attr("data-popOver-class",e)),r.find(".mapify-popOver-content").html(s),r.hasClass("mapify-to-bottom")?(r.css({marginTop:""}),r.hasClass("mapify-bottom")||a.css({marginLeft:h,transition:"none"}),r.addClass("mapify-bottom"),r.removeClass("mapify-to-bottom")):(r.hasClass("mapify-bottom")&&a.css({marginLeft:h,transition:"none"}),r.removeClass("mapify-bottom"),r.css({marginTop:-r.outerHeight()})),setTimeout(function(){r.css({top:v[1],left:v[0],transition:o._popOverTransition}).addClass("mapify-visible"),a.css({marginLeft:l,transition:o._popOverArrowTransition})},10)},100)},e.prototype._computePopOverCompensation=function(t){var i=0,o=0,s=this.popOver,e=this._getAreaCorners(t),r=e["center top"],a=s.outerWidth(),n=this.options.popOver.margin;this._mapHolder.width()<this.scrollParent.width()?(o=r[0]-a/2-this.scrollParent.scrollLeft())+a>this._mapHolder.width()-n?i=o+a-this._mapHolder.width()+n:o<n&&(i=o-n):(o=r[0]-a/2-this.scrollParent.scrollLeft())+a>this.scrollParent.outerWidth()-n?i=o+a-this.scrollParent.outerWidth()+n:o<n&&(i=o-n),r[1]-s.outerHeight()-n<0?(r=e["center bottom"],s.addClass("mapify-to-bottom")):s.hasClass("mapify-to-bottom")&&s.removeClass("mapify-to-bottom"),r[0]-=i;var p=i;return i>a/2-2*n?p=a/2-2*n:i<-(a/2-2*n)&&(p=-a/2+2*n),[i,p,r]},e.prototype._getAreaCorners=function(t){for(var i,o=t.getAttribute("coords").split(","),s=parseInt(o[0],10),e=s,r=parseInt(o[1],10),a=r,n=0,p=o.length;n<p;n++)i=parseInt(o[n],10),n%2==0?i<s?s=i:i>e&&(e=i):i<r?r=i:i>a&&(a=i);var h=parseInt((s+e)/2,10);parseInt((r+a)/2,10);return{"center top":{0:h,1:r},"center bottom":{0:h,1:a}}},e.prototype._clearMap=function(){var t=this;if(this.isPopOverEnabled){var i=!0,o="mapify-visible";if(this.isCustomPopOver){var s=this.options.popOver.customPopOver;o=s.visibleClass,i=!s.alwaysVisible}clearTimeout(this._popOverTimeout),i&&(this._popOverTimeout=setTimeout(function(){t.popOver.removeClass(o)},300))}this.svgMap.find("polygon").attr("class","mapify-polygon"),this.options.onMapClear&&this.options.onMapClear(this)},t.fn.mapify=function(i){return this.each(function(){t.data(this,"plugin_mapify")||t.data(this,"plugin_mapify",new e(this,t.extend(!0,{},r,i)))})},t.fn.mapify_scrollParent=function(){var i=this.css("position"),s="absolute"===i,e=this.parents().filter(function(){var i=t(this);return(!s||"static"!==i.css("position"))&&/(auto|scroll)/.test(i.css("overflow")+i.css("overflow-y")+i.css("overflow-x"))}).eq(0);return"fixed"!==i&&e.length?e:t(this[0].ownerDocument||o)}}(jQuery,window,document);

// la usa l'iframe !
// eslint-disable-next-line no-unused-vars
function goFullScreen() {
    console.log("goFullScreen...");
    const fullscreenDiv = document.querySelector('div.fullscreenable');
    if (fullscreenDiv.requestFullscreen) {
        fullscreenDiv.requestFullscreen();
    } else if (fullscreenDiv.webkitRequestFullscreen) { // Safari
        fullscreenDiv.webkitRequestFullscreen();
    } else if (fullscreenDiv.msRequestFullscreen) { // IE11
        fullscreenDiv.msRequestFullscreen();
    }
    const iFrame = document.querySelector('div.fullscreenable iframe');
    iFrame.style.height = "100%";
    return 123
}
document.addEventListener('fullscreenchange', () => {
    if (!document.fullscreenElement) {
        console.log('Exited fullscreen mode');
        const iFrame = document.querySelector('div.fullscreenable iframe');
        iFrame.style.height = "600px";
    }
});

export default {
    components: {
        Loading,
        Reminder,
    },
    props: {
        m: Object,
        name3D: String,
    },
    data() {
        return {
            remshow: 0,
            remdata: {},
            mailSent: false,
            fullPageWait: false,
            expandedRowKeys: [1, 2],
            selectedRowKeys: [1, 29, 42],
            // employees,
            // priorities,
            statuses,
            components: [],
            icoShow: false,
            icoCodice: "",
            icoRev: "",
            someOrdered: false,
            confirmOrder: false,
            hmap: "",
            code3d: null,
        };
    },
    updated() {
        console.log("updated")
        try {
            let div = document.querySelector('div.dx-treelist-headers')
            div.style.position = "relative"
            div.style['z-index'] = 999
            div.style['background-color'] = 'white'
            // let divs = document.querySelector('div.scrollami')
            // divs.addEventListener("scroll", (event) => {
            //     let y = divs.scrollTop
            //     console.log("scroll",event,y)
            //     if(y>167)
            //         div.style.top = (y - 167) + "px"
            //     else
            //     div.style.top = "0px"
            // });
        } catch (error) {
            console.error("Support Mount", error);
        }
        // this.$nextTick(function () {
        //     const area = document.querySelector('area');
        //     area.addEventListener('mouseover', () => {
        //         area.classList.add('permahover');
        //     });        
        // })

            setTimeout(()=>{
                $("img[usemap]:first").mapify({
                    popOver: {
                        content: function(zone){
                            return "<strong>"+zone.attr("data-title")+"</strong>";
                        },
                        delay: 0.2,
                        margin: "1px",
                        height: "80px",
                        width: "300px"
                    },
                    onAreaHighlight: function(){
                        console.log("onAreaHighlight callback");
                    },
                    onMapClear: function(){
                        console.log("onMapClear callback");
                    }
                });
                

                $("#dynamicClassChange").click(function() {
                    $(this).attr("data-hover-class","hover-green");
                });
            }, 50)

    },
    async mounted() {
        this.init();
        let hmap = await API.getHMAP(this.m.codice);
        let p1 = hmap.indexOf("src=") + 5;
        let p2 = hmap.indexOf('"', p1);
        hmap = hmap.substring(0, p1) + this.SERVER + '/2Dmap?k=' + this.m.codice + hmap.substring(p2);

        this.hmap = hmap;
    },
    computed: {
        orderVariant() {
            return this.someOrdered ? "info" : "";
        },
        orderDisabled() {
            return !this.someOrdered;
        },
        SERVER() {
            return SERVER;
        },
        dataSource() {
            return this.components;
        },
        orderItems() {
            return this.components.filter((c) => c.reorder && c.reorder > 0)
        },
    },
    methods: {
        close3d() {
            this.code3d = null
        },
        mapclick(evt) {
            console.log("mapclick", evt)
            if(evt.target.tagName == "AREA") {
                let code = evt.target.getAttribute("data-href")
                console.log("code", code)
                this.code3d = "3D/" + this.m.codice + "/" + code.split("=")[1] + "__" + this.name3D
                document.body.style.cursor = 'wait';

                // attendo che l'iframe sia caricato
                this.$nextTick(() => {
                    document.body.style.cursor = 'wait';
                    let iframe = this.$refs.frame3d;
                    iframe.onload = async () => {
                        // Controlla se la funzione è definita nell'iframe
                        if (iframe.contentWindow && typeof iframe.contentWindow.hook === 'function') {
                            // recupero C e FC e li passo al 3D
                            let items = await API.getTree(this.m.codice)
                            let c = items.data.filter(i => i.r).map(i => i.codice)
                            let fc = items.data.filter(i => i.sr).map(i => i.codice)
                            // faccio in modo che gli array contengano valori unici
                            c = [...new Set(c)]
                            fc = [...new Set(fc)]
                            // Chiama la funzione definita nell'iframe
                            let o = { c, fc }
                            console.log("HOOK")
                            iframe.contentWindow.hook(o, document, goFullScreen,this.close3d,this.remind,this.order,this.rfq);// il document serve per far fare lo scroll a 3D caricato
                        } else {
                            console.error("La funzione non è definita nell'iframe o l'iframe non è ancora caricato.");
                        }
                    };
                })
            }
        },
        showcode(c) {
            console.log("SHOWCODE", c)
        },
        order(objName, qty) {
            console.log("ORDER:", objName, qty)
            let tmp
            // se contiene "__" faccio split per "__", se contiene "  " faccio split per "  "
            if (objName.includes("__"))
                tmp = objName.split("__")
            else
                tmp = objName.split("  ")
            let o = { codice: tmp[0], descrizione: tmp[1], reorder: qty }
            console.log("ORDER:", o)
            let comp = this.components.find((c) => c.codice.split(' ')[0] == o.codice)
            console.log("COMP", comp)
            if (comp) {
                comp.reorder = qty
                this.checkNumOrdered()
            }
            // this.$store.commit("addOrder", o)
            // this.checkNumOrdered()
        },
        remind(objName) {
            console.log("REMIND:", objName)
            let tmp
            // se contiene "__" faccio split per "__", se contiene "  " faccio split per "  "
            if (objName.includes("__"))
                tmp = objName.split("__")
            else
                tmp = objName.split("  ")
            let o = { codice: tmp[0], descrizione: tmp[1] }
            this.remdata = o
            this.remshow++
        },
        cleanCode(c) { // elimina la parte aggiuntiva che impedisce il caricamento dell'immagine
            return c ? c.split(" ")[0] : c
        },
        async sendOrder() {
            console.log("invio...")
            let cname = await API.getClientName()
            let ccode = this.$store.getters.client_code
            let login = this.$store.getters.login
            let name = this.$store.getters.name
            let email = this.$store.getters.email
            let surname = this.$store.getters.surname
            let subj = `Offer request from ${ccode} - ${cname} - ${login} - ${name} ${surname} - ${email}`
            let to = "quote_mail"
            let text = `Ricontattare il cliente per i dettagli\r\n`
            let html = `<b>Ricontattare il cliente per i dettagli</b><br><br>Machine: ${this.m.codice}<br><table>`
            let xlsx = []
            for (let oi of this.orderItems) {
                let codice = oi.codice.split(" ")[0] // rimuovo la quantità fra parentesi
                text += `${codice} - ${oi.descrizione}\r\n`
                html += `<tr><td> ${codice} </td><td> ${oi.descrizione} </td><td> ${oi.reorder} </td></tr>`
                // xlsx.push([{ type: 'String', value: oi.codice},{ type: 'Number', value: oi.reorder}])
                xlsx.push([{ value: codice }, { value: oi.reorder }])
            }
            html += "</table>"
            await API.sendmail(to, subj, text, html, xlsx)
            this.mailSent = true
            for (let c of this.components) {
                c.reorder = 0
            }
        },
        checkNumOrdered() {
            let numord = this.components.filter((c) => c.reorder > 0).length;
            this.someOrdered = numord > 0
            console.log("numord", numord, this.components.filter((c) => c.reorder));
        },
        rfq() {
            this.confirmOrder = true
        },
        show(c, r) {
            this.icoCodice = c;
            this.icoRev = r;
            this.icoShow = true;
        },
        async init() {
            this.fullPageWait = true
            // console.log("M", this.m);
            let res = await API.getTree(this.m.codice);
            this.components = res.data;
            // console.log("components", this.components);
            // cerco tutti quelli già ordinati e setto il flag
            let ordered = await API.getSpares(this.m.codice);
            // let setted = 0;
            for (let o of ordered) {
                for (let c of this.components) {
                    if (c.codice == o.spare_code) {
                        c.ordered = true;
                        // setted++;
                    }
                }
            }
            // console.log("ordered", setted, ordered);
            // inserisco il primo che è la radice
            let root = this.components.find((c) => c.first == 1);
            if (root) {
                let padre = {
                    id_elemento: root.id_padre,
                    codice: this.m.codice,
                    descrizione: this.m.nome,
                    id_padre: 0,
                    r: false,
                    sr: false,
                    ordered: false,
                    reorder: 0,
                };
                for (let c of this.components) {
                    c.reorder = 0
                    c.codice = c.codice + ` (${c.qta})`
                }
                this.components.unshift(padre);
            }
            this.fullPageWait = false
            console.log("init components", this.components);
        },
        customizeTaskCompletionText(cellInfo) {
            return `${cellInfo.valueText}%`;
        },
    },
};
</script>
<style>
iframe {
    height: calc(100vh - 350px);
}
#showcomps button.btn-info {
    background-color: #6b1106;
    border-color: #6b1106;
}

#showcomps img.pointer {
    cursor: pointer;
}

#treecomponents {
    max-height: 100%;
    height: 100%;
}

#treecomponents .dx-treelist-rowsview td {
    vertical-align: middle;
}

#treecomponents div.dx-treelist-headers {
    margin-top: 90px;
}
</style>
<style scoped>
area {
    cursor: pointer;
}

.sendrfq {
    position: absolute;
    top: 85px;
    left: 1045px;
    width: 200px;
    z-index: 99;
}

div.billspieghe {
    position: absolute;
    left: 20px;
    z-index: 99;
    width: 750px;
    text-align: left;
    top: 70px;
    font-size: x-small;
}

h1 {
    position: absolute;
    left: 20px;
    z-index: 99;
}

h1 span.r {
    float: right;
    fill: white;
    margin-left: 100px;
    position: relative;
    bottom: 6px;
}

td {
    padding: 5px;
}

input.w50 {
    width: 50px;
}
</style>
<style type="text/css">
	.mapify-holder{position:relative;display:inline-block;font-size:0;max-width:100%;z-index:1;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.mapify-imgHolder{position:relative;z-index:1}.mapify-GPU,.mapify-holder *{-ms-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.mapify-imgHolder .mapify{max-width:100%;height:auto}.mapify-img{position:absolute;top:0;left:0;width:100%;height:100%;z-index:-2}.mapify-svg{position:absolute;top:0;left:0;width:100%;height:100%;z-index:-2}.mapify-polygon{transition:all .5s;fill:transparent;stroke:transparent;stroke-width:0}.mapify-hover{fill:#09f}.mapify-popOver{color:#000;position:absolute;top:0;left:0;padding:20px 30px;width:260px;background:#fff;box-shadow:rgba(0,0,0,.15) 0 0 0 2px;z-index:999;-ms-transform:translateY(-15px);transform:translateY(-15px);border-radius:5px;text-align:center;height:auto;box-sizing:border-box;-moz-box-sizing:border-box;font-size:14px;z-index:-1;opacity:0}.mapify-popOver .mapify-popOver-arrow{content:"";width:15px;height:15px;z-index:-2;margin-top:-3px;box-shadow:inset #fff 0 0 0 100px;border-top:solid transparent 2px;border-left:solid transparent 2px;border-right:solid rgba(0,0,0,.15) 2px;border-bottom:solid rgba(0,0,0,.15) 2px;position:absolute;top:100%;left:50%;-ms-transform:translateX(-15px) rotate(45deg) translateY(-50%);transform:translateX(-15px) rotate(45deg) translateY(-50%)}.mapify-popOver.mapify-bottom .mapify-popOver-arrow{top:auto;bottom:100%;margin-top:auto;margin-bottom:-3px;border-bottom:solid transparent 2px;border-right:solid transparent 2px;border-top:solid rgba(0,0,0,.15) 2px;border-left:solid rgba(0,0,0,.15) 2px;-ms-transform:rotate(45deg) translateY(50%);transform:rotate(45deg) translateY(50%)}.mapify-popOver.mapify-visible{opacity:1;-ms-transform:translateY(0);transform:translateY(0)}
</style>


<style type="text/css">

	/* div.showcomps{
		font-family: arial, sans-serif;
		font-weight: 400;
		font-size: 12px;
		text-align: center;
		margin: 0px;
		padding: 0px;
		cursor: default;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	} */
	
	/* Mapify custom popOver example */
	
	.mapify-visible {
		display: none;
	}
	.mapify-popOver strong{
		font-weight: 400;
		font-size:28px;
		line-height: 1em;
		display: block;
		margin-bottom: 10px;
		color: #000;
	}
	.mapify-popOver{
		color: #999;
		font-size: 28px;
		height: 130px;
	}
	.mapify-popOver-content{
		position: relative;
		top:50%;
		transform: translateY(-50%);
		-webkit-transform: translateY(-50%);
	}
	
	.mapify-popOver.customPopOver{
		background: #09f;
	}
	
	/* Custom hovering style */
	.mapify-hover{
		fill:rgba(0,0,0,0.15);
		/*stroke: #fff;*/
		stroke: rgb(253, 2, 2);
		stroke-width: 2;
	}
	
	.customHover{
		fill:#09f;
		stroke: #fff;
		stroke-width: 2;
	}
	
</style>
